import { useRoute } from "vue-router"

import { KirbyQueryResponse, KirbyQuerySchema } from "../queries/kql"
import { PathUtils } from "../utils/path.utils"

const envAPI = PathUtils.strip(import.meta.env.VITE_KIRBY_URL) + "/api/query"

export const getPage = async <T>(
  query: KirbyQuerySchema,
  api: string = envAPI,
) => {
  const route = useRoute()

  if (route?.query?.api) {
    api = `https://pr${route?.query?.api}.aaschool.ac.uk/api/query`
  }

  const response = await fetch(api, {
    method: "post",
    body: JSON.stringify(query),
  }).catch(e => {
    throw new Error("Failed to fetch Kirby JSON")
  })

  const json = (await response.json().catch(e => {
    throw new Error("Failed to parse Kirby JSON")
  })) as KirbyQueryResponse

  return json.result as T
}
